export enum SupplierImportSource {
  IMPORT_ORG = 'IMPORT_ORG',
  ORG_REGISTRATION = 'ORG_REGISTRATION',
}
